import { render } from "./PaymentsPage.vue?vue&type=template&id=42cba38a&scoped=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=js"
export * from "./PaymentsPage.vue?vue&type=script&lang=js"

import "./PaymentsPage.vue?vue&type=style&index=0&id=42cba38a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cba38a"]])

export default __exports__